import { Action } from 'redux';
import { combineEpics, StateObservable } from 'redux-observable';
import {
  distinctUntilChanged, filter, map, Observable, withLatestFrom,
} from 'rxjs';

import { SHUFFLE, LAST_BETS, PLACE_YOUR_BETS } from '@ezugi/constants';

import { userActions } from '../../actions';
import { roundStatusSelector, totalBetSelector, userBalanceSelector } from '../../selectors';

export const isBetTime = (roundStatus: string) => [ SHUFFLE, PLACE_YOUR_BETS, LAST_BETS ].includes(roundStatus);

export const realtimeBalanceEpicBetTime = (_: Observable<Action>, state$: StateObservable<any>) => state$.pipe(
  map((state) => ({
    totalBetValue: totalBetSelector(state),
    balance: userBalanceSelector(state),
    roundStatus: roundStatusSelector(state),
  })),
  distinctUntilChanged((prev, current) => prev.totalBetValue === current.totalBetValue
    && prev.balance === current.balance),
  filter(({ roundStatus }) => isBetTime(roundStatus)),
  map(({ balance, totalBetValue }) => userActions.user.set({ realtimeBalance: balance - totalBetValue })),
);

const realtimeBalanceEpicNotBetTime = (_: Observable<Action>, state$: StateObservable<any>) => state$.pipe(
  map((state) => ({
    balance: userBalanceSelector(state),
    roundStatus: roundStatusSelector(state),
  })),
  distinctUntilChanged((prev, current) => prev.balance === current.balance),
  filter(({ roundStatus }) => !isBetTime(roundStatus)),
  map(({ balance }) => userActions.user.set({ realtimeBalance: balance })),
);

export const realtimeBalanceEpicInvalidBet = (
  action$: Observable<Action>,
  state$: StateObservable<any>,
) => action$.pipe(
  filter(userActions.user.updateRealtimeBalanceWhenMainBetUnderLimit.match),
  withLatestFrom(state$),
  map(([ _, state ]) => {
    const balance = userBalanceSelector(state);
    return userActions.user.set({ realtimeBalance: balance });
  })
);

export default combineEpics(realtimeBalanceEpicBetTime, realtimeBalanceEpicNotBetTime, realtimeBalanceEpicInvalidBet);
